<template>
    <div style='touch-action: manipulation' class="mb-5">
      <div>
        <v-toolbar class="main">
          <button class="nav-back" @click="backToHome"><v-icon>keyboard_arrow_left</v-icon> Välj kund</button>
        </v-toolbar>
      </div>
      <h1 class="mb-3 title-go-left" style="text-align: center;">{{this.$store.state.activeCustomer.name}}</h1>
      <br>
      <div name="top"> <!--        Stepper Start         -->
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step step="1" :complete="e1 > 1"><span @click="e1 = 1">Lämnat</span></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="e1 > 2"><span @click="e1 = 2">Hämtat</span></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3"><span @click="e1 = 3">Signera</span></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
              <v-stepper-content step="1">
                <v-container grid-list-md text-xs-center inventory>
                  <v-layout row wrap mb-3>
                      <v-flex xs6>
                        <v-card>
                            <div class="image-container">
                                <img class="rounded" src="../assets/pallet.jpg">
                                <div class="description">Helpall</div>
                            </div>
                          <div class="counter">
                            <v-layout row wrap>
                              <v-flex xs4>
                                <v-btn  @click="$store.commit('decrementPalletAmountIn')"> - </v-btn>
                              </v-flex>
                              <v-flex xs4>
                                <input class="palletDisplay" v-model="pallet_quantity_in" readonly>
                              </v-flex>
                              <v-flex xs4>
                                <v-btn  @click="$store.commit('incrementPalletAmountIn')"> + </v-btn>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-card>
                      </v-flex>
                      <v-flex xs6>
                        <v-card>
                            <div class="image-container">
                                <img class="rounded" src="../assets/pallet-half.jpg">
                                <div class="description">Halvpall</div>
                            </div>

                          <div class="counter">
                            <v-layout row wrap>
                              <v-flex xs4>
                                <v-btn  @click="$store.commit('decrementPalletHalfAmountIn')"> - </v-btn>
                              </v-flex>
                              <v-flex xs4>
                                <input class="palletDisplay" v-model="pallet_half_quantity_in" readonly>
                              </v-flex>
                              <v-flex xs4>
                                <v-btn  @click="$store.commit('incrementPalletHalfAmountIn')"> + </v-btn>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-card>
                      </v-flex>
                      <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/rolling_pallet.jpg">
                                  <div class="description">Rullcontainer</div>
                              </div>
                            <div class="counter">
                              <v-layout row wrap>
                                <v-flex xs4>
                                  <v-btn  @click="$store.commit('decrementRollingPalletAmountIn')"> - </v-btn>
                                </v-flex>
                                <v-flex xs4>
                                  <input class="palletDisplay" v-model="rolling_pallet_quantity_in" readonly>
                                </v-flex>
                                <v-flex xs4>
                                  <v-btn  @click="$store.commit('incrementRollingPalletAmountIn')"> + </v-btn>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-card>
                      </v-flex>
                      <v-flex xs6>
                        <v-card>
                            <div class="image-container">
                                <img class="rounded" src="../assets/Engangspall.jpg">
                                <div class="description">Engångspall</div>
                            </div>

                            <div class="counter">
                                <v-layout row wrap>
                                    <v-flex xs4>
                                        <v-btn  @click="$store.commit('decrementDisposablePalletAmountIn')"> - </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <input class="palletDisplay" v-model="disposable_pallet_quantity_in" readonly>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn  @click="$store.commit('incrementDisposablePalletAmountIn')"> + </v-btn>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-card>
                      </v-flex>
                      <v-flex xs6>
                      <v-card>
                          <div class="image-container">
                              <img class="rounded" src="../assets/plastpall.jpg">
                              <div class="description">Plastpall</div>
                          </div>
                        <div class="counter">
                          <v-layout row wrap>
                            <v-flex xs4>
                              <v-btn  @click="$store.commit('decrementPlastpallAmountIn')"> - </v-btn>
                            </v-flex>
                            <v-flex xs4>
                              <input class="palletDisplay" v-model="plastpall_quantity_in" readonly>
                            </v-flex>
                            <v-flex xs4>
                              <v-btn  @click="$store.commit('incrementPlastpallAmountIn')"> + </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-card>
                      </v-flex>
                      <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/Plastpall-half.jpg">
                                  <div class="description">Plastpall Halv</div>
                              </div>

                              <div class="counter">
                                  <v-layout row wrap>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('decrementPlastpallHalfAmountIn')"> - </v-btn>
                                      </v-flex>
                                      <v-flex xs4>
                                          <input class="palletDisplay" v-model="plastpall_half_quantity_in" readonly>
                                      </v-flex>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('incrementPlastpallHalfAmountIn')"> + </v-btn>
                                      </v-flex>
                                  </v-layout>
                              </div>
                          </v-card>
                      </v-flex>
                      <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/lok-bin.jpg">
                                  <div class="description">Lök Bin</div>
                              </div>

                              <div class="counter">
                                  <v-layout row wrap>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('decrementLokbinAmountIn')"> - </v-btn>
                                      </v-flex>
                                      <v-flex xs4>
                                          <input class="palletDisplay" v-model="lokbin_quantity_in" readonly>
                                      </v-flex>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('incrementLokbinAmountIn')"> + </v-btn>
                                      </v-flex>
                                  </v-layout>
                              </div>
                          </v-card>
                      </v-flex>
                      <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/kyl.jpg">
                                  <div class="description">Kyl</div>
                              </div>

                              <div class="counter">
                                  <v-layout row wrap>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('decrementKylAmountIn')"> - </v-btn>
                                      </v-flex>
                                      <v-flex xs4>
                                          <input class="palletDisplay" v-model="kyl_quantity_in" readonly>
                                      </v-flex>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('incrementKylAmountIn')"> + </v-btn>
                                      </v-flex>
                                  </v-layout>
                              </div>
                          </v-card>
                      </v-flex>
                      <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/giant-cage.jpg">
                                  <div class="description">Jätten Bur</div>
                              </div>

                              <div class="counter">
                                  <v-layout row wrap>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('decrementGiantCageAmountIn')"> - </v-btn>
                                      </v-flex>
                                      <v-flex xs4>
                                          <input class="palletDisplay" v-model="giant_cage_quantity_in" readonly>
                                      </v-flex>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('incrementGiantCageAmountIn')"> + </v-btn>
                                      </v-flex>
                                  </v-layout>
                              </div>
                          </v-card>
                      </v-flex>
                  </v-layout>
                  <v-btn color="primary" block href="#top" @click="e1 = 2">Fortsätt</v-btn>
                </v-container>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-container grid-list-md text-xs-center inventory>
                  <v-layout row wrap mb-3>
                        <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/pallet.jpg">
                                  <div class="description">Helpall</div>
                              </div>

                            <div class="counter">
                              <v-layout row wrap>
                                <v-flex xs4>
                                  <v-btn  @click="$store.commit('decrementPalletAmountOut')"> - </v-btn>
                                </v-flex>
                                <v-flex xs4>
                                  <input class="palletDisplay" v-model="pallet_quantity_out" readonly>
                                </v-flex>
                                <v-flex xs4>
                                  <v-btn  @click="$store.commit('incrementPalletAmountOut')"> + </v-btn>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-card>
                        </v-flex>
                        <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/pallet-half.jpg">
                                  <div class="description">Halvpall</div>
                              </div>

                            <div class="counter">
                              <v-layout row wrap>
                                <v-flex xs4>
                                  <v-btn  @click="$store.commit('decrementPalletHalfAmountOut')"> - </v-btn>
                                </v-flex>
                                <v-flex xs4>
                                  <input class="palletDisplay" v-model="pallet_half_quantity_out" readonly>
                                </v-flex>
                                <v-flex xs4>
                                  <v-btn  @click="$store.commit('incrementPalletHalfAmountOut')"> + </v-btn>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-card>
                        </v-flex>
                        <v-flex xs6>
                            <v-card>
                                <div class="image-container">
                                    <img class="rounded" src="../assets/rolling_pallet.jpg">
                                    <div class="description">Rullcontainer</div>
                                </div>

                              <div class="counter">
                                <v-layout row wrap>
                                  <v-flex xs4>
                                    <v-btn  @click="$store.commit('decrementRollingPalletAmountOut')"> - </v-btn>
                                  </v-flex>
                                  <v-flex xs4>
                                    <input class="palletDisplay" v-model="rolling_pallet_quantity_out" readonly>
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-btn  @click="$store.commit('incrementRollingPalletAmountOut')"> + </v-btn>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </v-card>
                        </v-flex>
                        <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/Engangspall.jpg">
                                  <div class="description">Engångspall</div>
                              </div>

                              <div class="counter">
                                  <v-layout row wrap>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('decrementDisposablePalletAmountOut')"> - </v-btn>
                                      </v-flex>
                                      <v-flex xs4>
                                          <input class="palletDisplay" v-model="disposable_pallet_quantity_out" readonly>
                                      </v-flex>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('incrementDisposablePalletAmountOut')"> + </v-btn>
                                      </v-flex>
                                  </v-layout>
                              </div>
                          </v-card>
                        </v-flex>
                        <v-flex xs6>
                            <v-card>
                                <div class="image-container">
                                    <img class="rounded" src="../assets/plastpall.jpg">
                                    <div class="description">Plastpall</div>
                                </div>

                              <div class="counter">
                                <v-layout row wrap>
                                  <v-flex xs4>
                                    <v-btn  @click="$store.commit('decrementPlastpallAmountOut')"> - </v-btn>
                                  </v-flex>
                                  <v-flex xs4>
                                    <input class="palletDisplay" v-model="plastpall_quantity_out" readonly>
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-btn  @click="$store.commit('incrementPlastpallAmountOut')"> + </v-btn>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </v-card>
                        </v-flex>
                        <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/Plastpall-half.jpg">
                                  <div class="description">Plastpall Halv</div>
                              </div>

                              <div class="counter">
                                  <v-layout row wrap>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('decrementPlastpallHalfAmountOut')"> - </v-btn>
                                      </v-flex>
                                      <v-flex xs4>
                                          <input class="palletDisplay" v-model="plastpall_half_quantity_out" readonly>
                                      </v-flex>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('incrementPlastpallHalfAmountOut')"> + </v-btn>
                                      </v-flex>
                                  </v-layout>
                              </div>
                          </v-card>
                        </v-flex>
                        <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/lok-bin.jpg">
                                  <div class="description">Lök Bin</div>
                              </div>

                              <div class="counter">
                                  <v-layout row wrap>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('decrementLokbinAmountOut')"> - </v-btn>
                                      </v-flex>
                                      <v-flex xs4>
                                          <input class="palletDisplay" v-model="lokbin_quantity_out" readonly>
                                      </v-flex>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('incrementLokbinAmountOut')"> + </v-btn>
                                      </v-flex>
                                  </v-layout>
                              </div>
                          </v-card>
                        </v-flex>
                        <v-flex xs6>
                          <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/kyl.jpg">
                                  <div class="description">Kyl</div>
                              </div>

                              <div class="counter">
                                  <v-layout row wrap>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('decrementKylAmountOut')"> - </v-btn>
                                      </v-flex>
                                      <v-flex xs4>
                                          <input class="palletDisplay" v-model="kyl_quantity_out" readonly>
                                      </v-flex>
                                      <v-flex xs4>
                                          <v-btn  @click="$store.commit('incrementKylAmountOut')"> + </v-btn>
                                      </v-flex>
                                  </v-layout>
                              </div>
                          </v-card>
                        </v-flex>
                        <v-flex xs6>
                            <v-card>
                                <div class="image-container">
                                    <img class="rounded" src="../assets/giant-cage.jpg">
                                    <div class="description">Jätten Bur</div>
                                </div>

                                <div class="counter">
                                    <v-layout row wrap>
                                        <v-flex xs4>
                                            <v-btn  @click="$store.commit('decrementGiantCageAmountOut')"> - </v-btn>
                                        </v-flex>
                                        <v-flex xs4>
                                            <input class="palletDisplay" v-model="giant_cage_quantity_out" readonly>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-btn  @click="$store.commit('incrementGiantCageAmountOut')"> + </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-card>
                        </v-flex>
                        <v-flex xs6>
                            <v-card>
                              <div class="image-container">
                                  <img class="rounded" src="../assets/veg_crate.jpg">
                                  <div class="description">Back</div>
                              </div>

                            <div class="counter">
                              <v-layout row wrap>
                                <v-flex xs4>
                                  <v-btn  @click="$store.commit('decrementVegCrateAmountOut')"> - </v-btn>
                                </v-flex>
                                <v-flex xs4>
                                  <input class="palletDisplay" v-model="veg_crate_quantity_out" readonly>
                                </v-flex>
                                <v-flex xs4>
                                  <v-btn  @click="$store.commit('incrementVegCrateAmountOut')"> + </v-btn>
                                </v-flex>
                              </v-layout>
                            </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                  <v-card class="reminder">
                    <h3 class="mb-2">Kvar enligt lagersaldo</h3>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <div class="reminder-item">
                          <img class="rounded" src="../assets/rolling_pallet.jpg">
                          <input v-model="rolling_pallet_quantity_outstanding" readonly>
                        </div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="reminder-item">
                          <img class="rounded" src="../assets/pallet.jpg">
                          <input v-model="pallet_quantity_outstanding" readonly>
                        </div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="reminder-item">
                          <img class="rounded" src="../assets/pallet-half.jpg">
                          <input v-model="pallet_half_quantity_outstanding" readonly>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <v-btn color="primary" block href="#top" @click="e1 = 3">Fortsätt</v-btn>
                </v-container>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-container grid-list-md summary>
                  <v-card class="reciept">
                    <h2 class="mt-4 mb-3">Summering</h2>
                    <v-layout row wrap mb-3>
                      <v-flex xs6>
                        <ul class="summary mb-3">
                          <li><h3 class="mb-1">Incheckat</h3></li>
                          <li :class="{ mute:pallet_quantity_in_isEmpty }"><input v-model="pallet_quantity_in" readonly> Helpall</li>
                          <li :class="{ mute:pallet_half_quantity_in_isEmpty }"><input v-model="pallet_half_quantity_in" readonly> Halvpall</li>
                          <li :class="{ mute:rolling_pallet_quantity_in_isEmpty }"><input v-model="rolling_pallet_quantity_in" readonly> Rullcontainer</li>
                          <li :class="{ mute:plastpall_quantity_in_isEmpty }"><input v-model="plastpall_quantity_in" readonly> Plastpall</li>
                          <li :class="{ mute:plastpall_half_quantity_in_isEmpty }"><input v-model="plastpall_half_quantity_in" readonly> Plastpall Halv</li>
                          <li :class="{ mute:lokbin_quantity_in_isEmpty }"><input v-model="lokbin_quantity_in" readonly> Lökbin</li>
                          <li :class="{ mute:kyl_quantity_in_isEmpty }"><input v-model="kyl_quantity_in" readonly> Kyl</li>
                          <li :class="{ mute:giant_cage_quantity_in_isEmpty }"><input v-model="giant_cage_quantity_in" readonly> Jätten Bur</li>
                          <li :class="{ mute:disposable_pallet_quantity_in_isEmpty }"><input v-model="disposable_pallet_quantity_in" readonly> Engångspall</li>
                        </ul>
                      </v-flex>
                      <v-flex xs6>
                        <ul class="summary mb-3">
                          <li><h3 class="mb-1">Utcheckat</h3></li>
                          <li :class="{ mute:pallet_quantity_out_isEmpty }"><input v-model="pallet_quantity_out" readonly> Helpall</li>
                          <li :class="{ mute:pallet_half_quantity_out_isEmpty }"><input v-model="pallet_half_quantity_out" readonly> Halvpall</li>
                          <li :class="{ mute:rolling_pallet_quantity_out_isEmpty }"><input v-model="rolling_pallet_quantity_out" readonly> Rullcontainer</li>
                          <li :class="{ mute:veg_crate_quantity_out_isEmpty }"><input v-model="veg_crate_quantity_out" readonly> Back</li>
                          <li :class="{ mute:plastpall_quantity_out_isEmpty }"><input v-model="plastpall_quantity_out" readonly> Plastpall</li>
                          <li :class="{ mute:plastpall_half_quantity_out_isEmpty }"><input v-model="plastpall_half_quantity_out" readonly> Plastpall Halv</li>
                          <li :class="{ mute:lokbin_quantity_out_isEmpty }"><input v-model="lokbin_quantity_out" readonly> Lökbin</li>
                          <li :class="{ mute:kyl_quantity_out_isEmpty }"><input v-model="kyl_quantity_out" readonly> Kyl</li>
                          <li :class="{ mute:giant_cage_quantity_out_isEmpty }"><input v-model="giant_cage_quantity_out" readonly> Jätten Bur</li>
                          <li :class="{ mute:disposable_pallet_quantity_out_isEmpty }"><input v-model="disposable_pallet_quantity_out" readonly> Engångspall</li>
                        </ul>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <div>
                      <v-text-field class="mb-2" placeholder="Sök på namn" icon="search" v-model="filter"></v-text-field>
                      <br>
                  </div>
                  <div v-for="(signatory, i) in getSignatories" :key="i" >
                      <v-btn color="primary" block @click="setSignatoryByBtn(signatory)">{{ signatory }}</v-btn>
                      <br>
                  </div>
                  <div v-if="this.filter != ''">
                      <v-btn color="primary" block @click="setSignatoryByTextInput(filter)">Lägg till &quot;{{ this.filter }}&quot;</v-btn>
                  </div>
                </v-container>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div> <!--       Stepper End         -->
      </div>
    </div>
</template>

<script src="js/signature_pad.js"></script>
<script src="js/app.js"></script>
<script>
import { mapGetters, mapActions } from 'vuex'
import SignaturePad from 'signature_pad'
import required from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
  name: 'CheckInOut',
  data(){
    return{
      e1: 0,
      filter: "",
      select:null,
      valid: true,
      validations: {
        select: { required }
      },
      items: [
        {
          id: 1,
          name: 'Checka in'
        },
        {
          id: 2,
          name: 'Checka ut'
        },
        {
          id: 3,
          name: 'Signera',
        }
      ],
      active: null,
      showSigInput: false,
      sigInput: null,
      rolling_pallet_quantity_in_isEmpty: {},
      pallet_quantity_in_isEmpty: {},
      pallet_half_quantity_in_isEmpty: {},
      plastpall_quantity_in_isEmpty: {},
      plastpall_half_quantity_in_isEmpty: {},
      lokbin_quantity_in_isEmpty: {},
      kyl_quantity_in_isEmpty: {},
      giant_cage_quantity_in_isEmpty: {},
      disposable_pallet_quantity_in_isEmpty: {},
      pallet_quantity_out_isEmpty: {},
      pallet_half_quantity_out_isEmpty: {},
      rolling_pallet_quantity_out_isEmpty: {},
      veg_crate_quantity_out_isEmpty: {},
      plastpall_quantity_out_isEmpty: {},
      plastpall_half_quantity_out_isEmpty: {},
      lokbin_quantity_out_isEmpty: {},
      kyl_quantity_out_isEmpty: {},
      giant_cage_quantity_out_isEmpty: {},
      disposable_pallet_quantity_out_isEmpty: {}
    }
  },
  methods: {
    btnShowSigInput(){
      this.showSigInput = true;
      this.select = null;
    },
    setSignatoryByBtn(name){
        this.$store.state.transaction.signed = name;
        this.$router.push('Signature');
    },
    setSignatoryByTextInput(name){
        if (name !== null) {
            this.$store.state.transaction.signed = name;
            this.$router.push('Signature');
        } else {
            window.alert("Välj en u eller ange en ny.");
        }
    },
    backToHome(){
      this.$router.push('Driver_Home');
    }
  },
  computed: {
      getSignatories: function getSignatories(){
          var _this = this;
          //this.customers = this.$store.state.currentCustomers.slice(0, 50);
          var signatories = this.$store.state.currentSignatories.filter(function (player) {
              return player.toLowerCase().indexOf(_this.filter.toLowerCase()) !== -1;
          });

          return signatories;
      },
    rolling_pallet_quantity_in: {
      get(){
          if (this.$store.state.activeCustomer.rolling_pallet.quantity_in == 0) {
              this.rolling_pallet_quantity_in_isEmpty = true;
          } else {
              this.rolling_pallet_quantity_in_isEmpty = false;
          }
        return this.$store.state.activeCustomer.rolling_pallet.quantity_in;
      },
      set (){}
    },
    pallet_quantity_in: {
      get(){
          if (this.$store.state.activeCustomer.pallet.quantity_in == 0) {
              this.pallet_quantity_in_isEmpty = true;
          } else {
              this.pallet_quantity_in_isEmpty = false;
          }
        return this.$store.state.activeCustomer.pallet.quantity_in;
      },
      set (){}
    },
    pallet_half_quantity_in: {
      get(){
          if (this.$store.state.activeCustomer.pallet_half.quantity_in == 0) {
              this.pallet_half_quantity_in_isEmpty = true;
          } else {
              this.pallet_half_quantity_in_isEmpty = false;
          }
        return this.$store.state.activeCustomer.pallet_half.quantity_in;
      },
      set (){}
    },
    plastpall_quantity_in: {
      get(){
          if (this.$store.state.activeCustomer.plastpall.quantity_in == 0) {
              this.plastpall_quantity_in_isEmpty = true;
          } else {
              this.plastpall_quantity_in_isEmpty = false;
          }
        return this.$store.state.activeCustomer.plastpall.quantity_in;
      },
      set (){}
    },
    plastpall_half_quantity_in: {
      get(){
          if (this.$store.state.activeCustomer.plastpall_half.quantity_in == 0) {
              this.plastpall_half_quantity_in_isEmpty = true;
          } else {
              this.plastpall_half_quantity_in_isEmpty = false;
          }
        return this.$store.state.activeCustomer.plastpall_half.quantity_in;
      },
      set (){}
    },
    lokbin_quantity_in: {
      get(){
          if (this.$store.state.activeCustomer.lokbin.quantity_in == 0) {
              this.lokbin_quantity_in_isEmpty = true;
          } else {
              this.lokbin_quantity_in_isEmpty = false;
          }
        return this.$store.state.activeCustomer.lokbin.quantity_in;
      },
      set (){}
    },
    kyl_quantity_in: {
      get(){
          if (this.$store.state.activeCustomer.kyl.quantity_in == 0) {
              this.kyl_quantity_in_isEmpty = true;
          } else {
              this.kyl_quantity_in_isEmpty = false;
          }
        return this.$store.state.activeCustomer.kyl.quantity_in;
      },
      set (){}
    },
    giant_cage_quantity_in: {
      get(){
          if (this.$store.state.activeCustomer.giant_cage.quantity_in == 0) {
              this.giant_cage_quantity_in_isEmpty = true;
          } else {
              this.giant_cage_quantity_in_isEmpty = false;
          }
        return this.$store.state.activeCustomer.giant_cage.quantity_in;
      },
      set (){}
    },
    disposable_pallet_quantity_in: {
      get(){
          if (this.$store.state.activeCustomer.disposable_pallet.quantity_in == 0) {
              this.disposable_pallet_quantity_in_isEmpty = true;
          } else {
              this.disposable_pallet_quantity_in_isEmpty = false;
          }
        return this.$store.state.activeCustomer.disposable_pallet.quantity_in;
      },
      set (){}
    },
    rolling_pallet_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.rolling_pallet.quantity_out == 0) {
              this.rolling_pallet_quantity_out_isEmpty = true;
          } else {
              this.rolling_pallet_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.rolling_pallet.quantity_out;
      },
      set (){}
    },
    pallet_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.pallet.quantity_out == 0) {
              this.pallet_quantity_out_isEmpty = true;
          } else {
              this.pallet_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.pallet.quantity_out;
      },
      set (){}
    },
    pallet_half_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.pallet_half.quantity_out == 0) {
              this.pallet_half_quantity_out_isEmpty = true;
          } else {
              this.pallet_half_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.pallet_half.quantity_out;
      },
      set (){}
    },
    veg_crate_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.veg_crate.quantity_out == 0) {
              this.veg_crate_quantity_out_isEmpty = true;
          } else {
              this.veg_crate_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.veg_crate.quantity_out;
      },
      set (){}
    },
    plastpall_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.plastpall.quantity_out == 0) {
              this.plastpall_quantity_out_isEmpty = true;
          } else {
              this.plastpall_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.plastpall.quantity_out;
      },
      set (){}
    },
    plastpall_half_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.plastpall_half.quantity_out == 0) {
              this.plastpall_half_quantity_out_isEmpty = true;
          } else {
              this.plastpall_half_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.plastpall_half.quantity_out;
      },
      set (){}
    },
    lokbin_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.lokbin.quantity_out == 0) {
              this.lokbin_quantity_out_isEmpty = true;
          } else {
              this.lokbin_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.lokbin.quantity_out;
      },
      set (){}
    },
    kyl_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.kyl.quantity_out == 0) {
              this.kyl_quantity_out_isEmpty = true;
          } else {
              this.kyl_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.kyl.quantity_out;
      },
      set (){}
    },
    giant_cage_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.giant_cage.quantity_out == 0) {
              this.giant_cage_quantity_out_isEmpty = true;
          } else {
              this.giant_cage_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.giant_cage.quantity_out;
      },
      set (){}
    },
    disposable_pallet_quantity_out: {
      get(){
          if (this.$store.state.activeCustomer.disposable_pallet.quantity_out == 0) {
              this.disposable_pallet_quantity_out_isEmpty = true;
          } else {
              this.disposable_pallet_quantity_out_isEmpty = false;
          }
        return this.$store.state.activeCustomer.disposable_pallet.quantity_out;
      },
      set (){}
    },
    rolling_pallet_quantity_outstanding: function(){
        return this.$store.state.activeCustomer.rolling_pallet.quantity_outstanding - this.rolling_pallet_quantity_out;
    },
    pallet_quantity_outstanding: function(){
        return this.$store.state.activeCustomer.pallet.quantity_outstanding - this.pallet_quantity_out;
    },
    pallet_half_quantity_outstanding: function(){
        return this.$store.state.activeCustomer.pallet_half.quantity_outstanding - this.pallet_half_quantity_out;
    }
  },
  created: function(){
      console.log("Token: ", this.$store.state.auth.token);
      console.log("activeCustomer: ", this.$store.state.activeCustomer);
      this.$store.state.fetchFailed = false;

      if(this.$store.state.auth.token == null || this.$store.state.auth.token == ""){
          window.alert("Fel: Vänligen logga in");
          this.$router.push('/');
      }

      if(this.$store.state.activeCustomer === null || this.$store.state.activeCustomer.name === "" || this.$store.state.activeCustomer === {} || this.$store.state.activeCustomer.address == ""){
          window.alert("Fel: Vänligen välj kund");
          this.$router.push('/Driver_Home');
      }
  }
}
</script>

<style>
[v-cloak] {
  display: none;
}

.stepper:not(.stepper--vertical) .stepper__label{
  display:inherit!important;
}

.palletDisplay{
  width: 33%;
  text-align: center;
}

.image-container{
    position: relative;
    top: 0px;
}

img.rounded {
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
}

</style>



// WEBPACK FOOTER //
// src/components/CheckInOut.vue